import { Col, Typography } from "antd";
import React from "react";
import { SOLOOP_LOGO } from "../../../constants/svgs";
import useBreakpoints from "../../../hooks/use-breakpoints";
import { BREAKPOINTS } from "../../../constants/styles";
import { Link } from "react-router-dom";
import { routes } from "../../../constants/routes";
import { VIEWS } from "../../../constants/global";

import "./styles.desktop.scss";
const { Text } = Typography;

const HeaderDesktop = () => {
  const currentBreakpoint = useBreakpoints();

  const isMediumOrSmallScreen =
    currentBreakpoint === BREAKPOINTS.MEDIUM_DESKTOP.type ||
    currentBreakpoint === BREAKPOINTS.SMALL_DESKTOP.type;

  const logoWidth = isMediumOrSmallScreen ? "112" : "153.77";
  const logoHeight = isMediumOrSmallScreen ? "45.16" : "62";

  return (
    <>
      <Col span={6}>
        <Link to={routes[VIEWS.HOME].fullPath}>
          {SOLOOP_LOGO(logoWidth, logoHeight)}
        </Link>
      </Col>
      <Col>
        <div className="Header-desktop-links">
          <Link
            to={routes[VIEWS.HOME].fullPath}
            className="Header-desktop-link-wrapper"
          >
            <Text className="Header-desktop-link">Home</Text>
          </Link>
          <Link
            to={routes[VIEWS.OUR_WORK].fullPath}
            className="Header-desktop-link-wrapper"
          >
            <Text className="Header-desktop-link">Our Work</Text>
          </Link>
          <Link
            to={routes[VIEWS.SERVICES].fullPath}
            className="Header-desktop-link-wrapper"
          >
            <Text className="Header-desktop-link">Services</Text>
          </Link>
          <Link
            to={routes[VIEWS.ABOUT_US].fullPath}
            className="Header-desktop-link-wrapper"
          >
            <Text className="Header-desktop-link">About Us</Text>
          </Link>
          {/*<Link
            to={routes[VIEWS.BLOG].fullPath}
            className="Header-desktop-link-wrapper"
          >
            <Text className="Header-desktop-link">Blog</Text>
          </Link>*/}
          <Link
            to={routes[VIEWS.CONTACT].fullPath}
            className="Header-desktop-link-wrapper"
          >
            <Text className="Header-desktop-link">Contact</Text>
          </Link>
        </div>
      </Col>
    </>
  );
};

export default HeaderDesktop;
